<template>
  <div id="app">
    <!-- 导航 -->
    <nav-header />
    <!-- 轮播 -->
    <nav-swiper />
    <!-- 内容 -->
    <router-view />
    <!-- 页脚 -->
    <nav-footer />
  </div>
</template>

<script>
  import NavHeader from '@/views/layout/NavHeader.vue';
  import NavFooter from './views/layout/NavFooter.vue';
  import NavSwiper from './views/layout/NavSwiper.vue';

  export default {
    components: { NavHeader, NavFooter, NavSwiper },
    data() {
      return {};
    },
  };
</script>

<style lang="less" scoped></style>
